import React from 'react';
import { Helmet } from 'react-helmet';
import {
  about1,
  about2,
  about_usImg,
  aboutBg,
  saycheezeAbout1,
  saycheezeAbout2,
} from '../../../../assets/images';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination, Autoplay } from 'swiper/modules';

const About = () => {
  const aboutPoints = [
    {
      desc: 'SayCheeze began as a passion project—born from a mother’s love for baking and a commitment to quality. As a home baker, I wanted only the best for my child, and now I bring that same dedication to every cake we create.',
    },
    {
      desc: 'We turn cravings into celebrations! With a passion for artistry and flavor, we craft exquisite bakes at affordable prices, using only the finest ingredients.',
    },
    {
      desc: 'Whether it’s a special occasion or just a well-deserved treat, you don’t need a reason to indulge. Because every bite should be a moment to savor. Celebrate your craving with SayCheeze! 🍰💛',
    },
    {
      title: 'Premium Quality',
      desc: 'Only the best ingredients make it into our cakes, ensuring every bite is fresh, rich, and unforgettable.',
    },
    {
      title: 'Exquisite Fillings',
      desc: 'From decadent caramel to exotic fruit blends and smooth chocolate ganaches, each filling is carefully crafted to enhance the flavor profile.',
    },
    {
      title: 'Unmatched Flavors',
      desc: 'Experience a symphony of flavors, from classic to adventurous, that cater to every palate and occasion.',
    },
    {
      title: 'Perfect for Every Occasion',
      desc: " Whether it's a birthday, celebration, or just a special treat, our cakes are designed to impress.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>About SayCheeze Cakes – Premium Custom Cakes in Bangalore</title>
        <meta
          name='description'
          content='Learn about SayCheeze Cakes – a Bangalore-based home bakery crafting premium custom cakes, cheesecakes, and desserts with high-quality ingredients and creative designs.'
        />
        <link rel='canonical' href='https://www.saycheezecakes.com/about' />
      </Helmet>

      <div
        className='breadcrumb breadcrumb-about'
        style={{ backgroundImage: `url(${saycheezeAbout1})` }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='breadcrumb_content'>
                <h1 className='breadcrumb_title'>About Us</h1>
                <p className='breadcrumb_text'>
                  At SayCheeze, we craft edible masterpieces with love and creativity, using the
                  finest ingredients to make every moment sweeter.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='section-padding-03 overflow-hidden'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6'>
              <div className='section-title-10 justify-content-start text-start align-items-start'>
                <span className='section-title-10__subtitle'>We Are Bakerfresh</span>
                <h1 className='section-title-10__title'>Why Our Cakes Stand Out?</h1>

                {aboutPoints?.map((point, i) => (
                  <p className='section-title-10__text' key={i}>
                    {point?.title && (
                      <>
                        <b>{point?.title}: </b>
                      </>
                    )}
                    {point?.desc}
                  </p>
                ))}

                {/* <img src='assets/images/singnecher-2.png' alt='Signature-Image' /> */}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='aboutus-image'>
                <img src={saycheezeAbout2} alt='About-Image' />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='section-padding-03 overflow-hidden'>
        <div className='container'>
          <div className='row flex-md-row-reverse align-items-center'>
            <div className='col-md-5'>
              <div className='section-title-10 justify-content-start text-start align-items-start'>
                <span className='section-title-10__subtitle'>Bakerfresh Time</span>
                <h1 className='section-title-10__title'>dispatch timings</h1>
                <p className='section-title-10__text'>
                  Our dispatch timings are designed to ensure prompt and efficient delivery of your
                  orders.
                </p>
              </div>
              <ul className='about-schedule'>
                <li>
                  <span className='about-schedule_name'>Mon - Sat</span>
                  <span className='about-schedule_time'>3:00 pm - 7:00 pm</span>
                </li>
                <li>
                  <span className='about-schedule_name'> Sun</span>
                  <span className='about-schedule_time'>Closed</span>
                </li>
              </ul>
            </div>
            <div className='col-md-7'>
              <div className='aboutus-image-two'>
                <img src={about_usImg} alt='About-Image' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
